import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./GuestEntry.css";

import kanchiLogo from "../Assets/logo/KanchiLogo.png";
import bottomBorder from "../Assets/LandingPage/kolam-border.png";
import GoldenButton from "../Components/GoldenButton/GoldenButton";
import ValidationModal from "../Components/ValidationModal/ValidationModal";

const GuestEntry = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("+91");
  const [guests, setGuests] = useState("");

  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const showError = (message) => {
    setModalMessage(message);
    setShowModal(true);
  };

  const handleMobileChange = (e) => {
    let value = e.target.value;

    // Always enforce +91 prefix
    if (!value.startsWith("+91")) {
      value = "+91";
    }

    // Extract digits after +91
    let digits = value.replace("+91", "").replace(/\D/g, "");

    // Limit to 10 digits
    if (digits.length > 10) {
      digits = digits.slice(0, 10);
    }

    setMobile("+91" + digits);
  };

  const validateForm = () => {
    if (!name.trim()) {
      showError("Please enter your name.");
      return false;
    }

    if (mobile.length <= 3) {
      showError("Mobile number is required.");
      return false;
    }

    const digits = mobile.replace("+91", "");
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!phoneRegex.test(digits)) {
      showError("Please enter a valid 10-digit Indian mobile number.");
      return false;
    }

    if (!guests || guests <= 0) {
      showError("Please enter number of guests.");
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      // ✅ Create guest object
      const guestData = {
        name: name.trim(),
        mobile,
        guests: Number(guests),
        entryTime: new Date().toISOString(),
      };

      // ✅ Store in localStorage
      localStorage.setItem("kanchiGuest", JSON.stringify(guestData));

      // Navigate to menu
      navigate("/kanchi-menu");
    }
  };

  return (
    <div className="guest-container">
      <div className="guest-logo-wrapper">
        <img src={kanchiLogo} alt="Kanchi Cafe" className="guest-logo" />
      </div>

      <div className="guest-card">
        <h2 className="guest-title">Enter as Our Honored Guest</h2>

        <div className="input-group">
          <label>NAME</label>
          <input
            type="text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="input-group">
          <label>MOBILE NUMBER</label>
          <input
            type="text"
            value={mobile}
            onChange={handleMobileChange}
          />
        </div>

        <div className="input-group">
          <label>NUMBER OF GUESTS</label>
          <input
            type="number"
            value={guests}
            onChange={(e) => setGuests(e.target.value)}
          />
        </div>

        <GoldenButton className="guest-btn" onClick={handleSubmit}>
          Proceed to Menu
        </GoldenButton>
      </div>

      <img src={bottomBorder} alt="border" className="bottom-border" />

      {showModal && (
        <ValidationModal
          message={modalMessage}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default GuestEntry;
